import { createSelector } from 'reselect';

import { getRequestStatus } from '../../requests/selectors';
import { CREATE_BOOKING, GET_DEPOSIT, SET_DISCOUNT_CODE } from './action-types';

export const pendingParamsSelector = (state) => state.booking.booking.pendingParams;
export const typeSelector = (state) => state.booking.booking.type;
export const isNewBookingSelector = (state) => state.booking.booking.type === 'new';
export const bookingChannelIdSelector = (state) => state.booking.booking.channelId;
export const isEuroBookingSelector = (state) => state.booking.booking.channelId === 'eurocaravan';
export const parkIdSelector = (state) => state.booking.booking.parkId;
export const unitIdSelector = (state) => state.booking.booking.unitId;
export const unitTypeIdSelector = (state) => state.booking.booking.unitTypeId;
export const unitPriceSelector = (state) => state.booking.booking.unitPrice; // new bookings only!
export const totalCostSelector = (state) => state.booking.booking.totalCost; // existing bookings only!
export const amountPaidSelector = (state) => state.booking.booking.amountPaid; // existing bookings only!
export const discountAppliedSelector = (state) => state.booking.booking.discountApplied;
export const discountCodeSelector = (state) => state.booking.booking.discountCode;
export const discountValueSelector = (state) => state.booking.booking.discountValue;
export const bookingArrivalDateSelector = (state) => state.booking.booking.arrivalDate;
export const bookingDurationSelector = (state) => state.booking.booking.duration;
export const bookingIdSelector = (state) => state.booking.booking.bookingId;
export const depositSelector = (state) => state.booking.booking.deposit;
export const compulsoryDepositSelector = (state) => state.booking.booking.compulsoryDeposit;
export const depositTextSelector = (state) => state.booking.booking.depositText;
export const dueDateSelector = (state) => state.booking.booking.dueDate;
export const confirmationIdSelector = (state) => state.booking.booking.confirmationId;
export const messageSelector = (state) => state.booking.booking.message;
export const customBookingPaymentSelector = (state) => state.booking.booking.customBookingPayment;
export const customBookingPaymentErrSelector = (state) => state.booking.booking.customBookingPaymentErr;
export const paidWithFullVoucherSelector = (state) => state.booking.booking.paidWithFullVoucher;
export const previousBookingIdSelector = (state) => state.booking.booking.previousBookingId;
export const partyBookingSelector = (state) => state.booking.booking.party;
export const parkBookingUrlSelector = (state) => state.booking.booking.parkBookingUrl;
export const promoBookingSelector = (state) => state.booking.booking?.promo;
export const bookingFeeSelector = (state) => state.booking.booking.bookingFee;
export const bookingModeSelector = (state) =>
  state.homepage.content.find((item) => item.type.includes('HeroText')).data.booking_mode;
export const bookingTimedOutSelector = (state) => state.booking.booking?.bookingTimedOut;

// We save the discount code wether its valid or not, this only returns code if it is valid and reduced the cost
export const validDiscountCodeSelector = createSelector(discountValueSelector, discountCodeSelector, (value, code) => {
  return value > 0 ? code : undefined;
});

export const [bookingIsFetchingSelector, bookingHasErrorSelector, bookingErrorDataSelector] =
  getRequestStatus(CREATE_BOOKING);
export const bookingIsLoadedSelector = (state) => typeof bookingIdSelector(state) !== 'undefined';

export const [depositIsFetchingSelector, depositHasErrorSelector, depositErrorDataSelector] =
  getRequestStatus(GET_DEPOSIT);
export const depositIsLoadedSelector = (state) => typeof depositSelector(state) !== 'undefined';

export const stepsCompletedSelector = (state) => state.booking.booking.stepsCompleted;

export const unitPriceNumSelector = createSelector(unitPriceSelector, (_unitPrice) => {
  return typeof _unitPrice !== 'undefined' ? parseFloat(_unitPrice) : undefined;
});

export const depositAvailableSelector = (state) => typeof depositSelector(state) === 'number';

export const depositIsCompulsorySelector = (state) => typeof compulsoryDepositSelector(state) !== 'undefined';

export const [settingDiscountSelector, settingDiscountFailedSelector, settingDiscountErrorSelector] =
  getRequestStatus(SET_DISCOUNT_CODE);

export const bookingFeeNumSelector = createSelector(bookingFeeSelector, (_bookingFee) => {
  return typeof _bookingFee !== 'undefined' ? parseFloat(_bookingFee) : undefined;
});
